/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  LaunchTraceabilityMutationRequest,
  LaunchTraceabilityMutationResponse,
} from "../types/LaunchTraceability.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const launchTraceabilityMutationKey = () =>
  [{ url: "/v1/product/launch-traceability" }] as const

export type LaunchTraceabilityMutationKey = ReturnType<
  typeof launchTraceabilityMutationKey
>

/**
 * @summary Launch traceability
 * {@link /v1/product/launch-traceability}
 */
export async function launchTraceability(
  data: LaunchTraceabilityMutationRequest,
  config: Partial<RequestConfig<LaunchTraceabilityMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    LaunchTraceabilityMutationResponse,
    ResponseErrorConfig<Error>,
    LaunchTraceabilityMutationRequest
  >({
    method: "POST",
    url: `/v1/product/launch-traceability`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function launchTraceabilityMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<LaunchTraceabilityMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = launchTraceabilityMutationKey()
  return mutationOptions<
    ResponseConfig<LaunchTraceabilityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: LaunchTraceabilityMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return launchTraceability(data, config)
    },
  })
}

/**
 * @summary Launch traceability
 * {@link /v1/product/launch-traceability}
 */
export function useLaunchTraceability<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<LaunchTraceabilityMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: LaunchTraceabilityMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<LaunchTraceabilityMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? launchTraceabilityMutationKey()

  const baseOptions = launchTraceabilityMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<LaunchTraceabilityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: LaunchTraceabilityMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<LaunchTraceabilityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: LaunchTraceabilityMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<LaunchTraceabilityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: LaunchTraceabilityMutationRequest },
    TContext
  >
}
